export default __webpack_public_path__ + "041e96314fd465f39822b318227e31a6.png";